// These ids are meant to be used for test automation tools such as end to end testing (Selenium, Cypress, etc) but
// also for load testing tools that can record and replay a user session.
// It's important not to change or remove these unless you're absolutely sure that no such tool uses the id.
// It's highly encouraged to add new ids and then add the prop to an element (see usages of the TestIdProps object).
// Mainly used by https://github.com/avensia/testAutomation

export const TestIds = {
  // Page-location
  CheckoutPage: 'checkout-page',
  ProductDetailPage: 'pdp-page',
  HomePage: 'home-page',

  // Shortcut button
  MyPagesLink: 'my-pages-link',
  MyWishlistLink: 'my-wishlist-link',
  CustomerServiceLink: 'customer-service-link',
  MiniCartLink: 'minicart-link',
  StoresLink: 'stores-link',
  WebsiteTitle: 'website-title',

  // Product navigation
  ProductCategoryTabs: 'product-category-tabs',
  ProductLink: 'product-link',
  ToggleSidebarMenu: 'toggle-sidebar-menu-button',
  CloseSideBarMenu: 'close-sidebar-menu-button',
  SideBarProductCategory: 'sidebar-product-category',
  goToCheckoutButton: 'to-checkout-button',
  MegaMenu: 'mega-menu',
  MegaMenuProductCategory: 'mega-menu-product-category',

  // Members (login, forgot password etc)
  OpenLoginButton: 'open-login-button',
  ForgotPasswordButton: 'forgot-password-button',
  LoginButton: 'login-button',
  LoginFailedElement: 'login-failed-element',
  LoginEmailInput: 'login-email-input',
  LoginPasswordInput: 'login-password-input',
  RegisterButton: 'register-button',
  RegisterFailedElement: 'register-failed-element',
  RegisterEmailInput: 'register-email-input',
  RegisterPasswordInput: 'register-password-input',
  RegisterAcceptTermsInput: 'register-accept-terms-input',

  // Checkout
  IncreaseQuantityButton: 'increase-quantity-button',
  DecreaseQuantityButton: 'decrease-quantity-button',
  CompleteShippingSettingsButton: 'complete-shipping-settings-button',
  CurrentCheckoutProviderKlarna: 'current-checkout-provider-klarna',
  CurrentCheckoutProviderAdyen: 'current-checkout-provider-adyen',
  CurrentCheckoutProviderPaypal: 'current-checkout-provider-paypal',
  ToggleVoucherInput: 'toggle-voucher-input-checkbox',
  VoucherList: 'voucher-list',
  VoucherInputField: 'voucher-input',
  AcceptTermsCheckbox: 'toggle-accept-terms-checkbox',
  CompletePurchaseButton: 'complete-purchase-button',
  CompleteUserDataFormButton: 'complete-user-data-form-button',
  SelectShippingMethodInput: 'select-shipping-method-input',
  SelectPaymentMethodInput: 'select-payment-method-input',
  OrderConfirmationText: 'order-confirmation-text',

  // Minicart
  QuantityInput: 'quantity-input',
  MiniCartElement: 'minicart-element',
  MiniCartItemElement: 'minicart-item-element',
  RemoveMiniCartItemButton: 'remove-minicart-item-button',
  AddToCartButton: 'add-to-cart-button',

  // Product Page
  OpenMonitorBackInStockButton: 'open-monitor-back-in-stock-button',
  MonitorBackInStockEmailInput: 'monitor-back-in-email-input',
  MonitorBackInStockButton: 'monitor-back-in-stock-button',
  ToggleWishlistItemButton: 'toggle-wishlist-item-button',
  VariantSelectorElement: 'variant-selector-element',
  ProductDetailPageConfigurator: 'pdp-configurator',
  ProductDetailPageInfo: 'pdp-info',
  ProductDetailPageBuySection: 'pdp-buy-section',
  ProductDetailPagePrice: 'pdp-price',
  StockStatus: 'stock-status',
  NewProductFlagPDP: 'new-product-flag-pdp',

  // Search
  SearchResultText: 'search-result-text',
  SearchButton: 'search-button',
};
type TestIdsType = typeof TestIds;

export const testIdAttribute = 'data-test-id';

export const TestIdProps: {
  [P in keyof TestIdsType]: ReturnType<typeof testId>;
} = {} as any;
for (const key of Object.keys(TestIds)) {
  (TestIdProps as any)[key] = testId(key as keyof TestIdsType);
}

export function testId(id: keyof TestIdsType) {
  return { [testIdAttribute]: TestIds[id] };
}
